import React, { useEffect, useState } from "react";
import { UserI } from "../typings/interfaces";
import { GoogleAdConfig } from "../services";

export interface FloatingComponentProps {
  config?: GoogleAdConfig;
  className?: string;
  noBottomMargin?: boolean;
  noTopMargin?: boolean;
  lockScrollHeight?: number;
  onSubmitAdClick?: Function;
  showLogoAndSearchBar?: boolean;
  transparent?: boolean;
  isHomePage?: boolean;
  user?: UserI | null;
  placeholderHeight?: number;
  adLoadCallback?: (adId: string) => void;
}

export default (Com: Function) => {
  const FloatingComponent = (props: FloatingComponentProps) => {
    const [scrollingLock, setScrollingLock] = useState(false);

    useEffect(() => {
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    const handleScroll = () => {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      const { lockScrollHeight } = props;

      setScrollingLock(scrollY > lockScrollHeight);
    };

    return <Com {...props} scrollingLock={scrollingLock} />;
  };

  FloatingComponent.defaultProps = {
    lockScrollHeight: 62
  };

  return FloatingComponent;
};



// WEBPACK FOOTER //
// ./src/HOCs/handleFloating.tsx